export const NEWS_API = () => {
  return 'https://hn.algolia.com/api/v1/search?'
}
